/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__on_the_way_section__filters__detour = /** @type {(inputs: {}) => string} */ () => {
	return `Unterwegs`
};

const en_route_details__on_the_way_section__filters__detour = /** @type {(inputs: {}) => string} */ () => {
	return `On the way`
};

const es_route_details__on_the_way_section__filters__detour = /** @type {(inputs: {}) => string} */ () => {
	return `Por el camino`
};

const fr_route_details__on_the_way_section__filters__detour = /** @type {(inputs: {}) => string} */ () => {
	return `Sur le trajet`
};

const it_route_details__on_the_way_section__filters__detour = /** @type {(inputs: {}) => string} */ () => {
	return `Lungo il percorso`
};

const nl_route_details__on_the_way_section__filters__detour = /** @type {(inputs: {}) => string} */ () => {
	return `Onderweg`
};

const pt_route_details__on_the_way_section__filters__detour = /** @type {(inputs: {}) => string} */ () => {
	return `Durante o trajeto`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__detour = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__on_the_way_section__filters__detour(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__on_the_way_section__filters__detour", locale)
	if (locale === "de") return de_route_details__on_the_way_section__filters__detour(inputs)
	if (locale === "en") return en_route_details__on_the_way_section__filters__detour(inputs)
	if (locale === "es") return es_route_details__on_the_way_section__filters__detour(inputs)
	if (locale === "fr") return fr_route_details__on_the_way_section__filters__detour(inputs)
	if (locale === "it") return it_route_details__on_the_way_section__filters__detour(inputs)
	if (locale === "nl") return nl_route_details__on_the_way_section__filters__detour(inputs)
	return pt_route_details__on_the_way_section__filters__detour(inputs)
};